import {makeStyles} from "tss-react/mui";
import {Box, CircularProgress, Typography} from "@mui/material";
import {ModuleSummaryCard} from "@/components/module/ModuleSummaryCard";
import {palette} from "@/constants";
import {ExpandMore} from "@mui/icons-material";
import {Link} from "react-router-dom";
import {useRecentActivity} from "./hooks";
import {useSSTranslation} from "@/i18n/useSSTranslation";

const useStyles = makeStyles()((theme) => ({
	recentCompletedModules: {
		display: "flex",
		flexDirection: "column",
		gap: "10px",
		padding: "15px",
		border: "1px solid " + palette.grey08,
		borderRadius: "16px",
		background: "#282828"
	},
	centerWrapper: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		flexDirection: "column"
	},
	expandIcon: {
		fill: theme.palette.primary.main,
		fontSize: "32px",
		[theme.breakpoints.down("sm")]: {
			display: "none"
		},
		margin: "0",
		color: theme.palette.secondary.main
	},
	viewAllContainer: {
		textAlign: "center",
		width: "100%",
		display: "flex",
		gap: "5px",
		cursor: "pointer",
		justifyContent: "center",
		"& svg": {
			margin: "-4px"
		},
		"& [class*='MuiCircularProgress-root']": {
			width: "10px !important",
			height: "10px !important",
			margin: "7px"
		},
		"& p": {
			fontWeight: 600,
			fontSize: "16px"
		}
	}
}));

export const MyRecentCompletedModules: React.FC = () => {
	const {classes} = useStyles();
	const {t} = useSSTranslation();
	const {activities, isLoading, hasMore, loadMore} = useRecentActivity();

	return (
		<Box className={classes.recentCompletedModules}>
			{(isLoading && activities.length === 0) && <div className={classes.centerWrapper}><CircularProgress color="secondary" /></div>}
			{!isLoading && activities.length === 0 && <Typography>{t("page_progress_no_recent_activity", "No recent activity")}</Typography>}
			{activities.map((activity: any) =>
				<Link to={`/course/${activity.course.slug}/${activity.type}/${activity.slug}`} key={activity.id}>
					<ModuleSummaryCard module={{...activity, complete: false}} />
				</Link>
			)}
			{hasMore && (
				<Box className={classes.viewAllContainer} onClick={loadMore}>
					<Typography>{t("view_more", "View more")}</Typography>
					{isLoading && <CircularProgress/>}
					{!isLoading && <ExpandMore className={classes.expandIcon} />}
				</Box>
			)}
		</Box>
	);
}
